exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* \n  Since 4.10.0, you don't need to import css flie any more,\n  this flie is only used for backward compatible. Maybe deleted  \n  in the future.\n*/\n", ""]);

// exports
